const highlightRows = (row) => {
  const table = document.getElementById("TET_Table");
  const rows = table.getElementsByTagName("tr");
  rows[row].style.backgroundColor = "rgba(231, 49, 49, 0.32)";
};
export const parseTable = (tableId) => {
  const table = document.getElementById(tableId);
  const rows = table.getElementsByTagName("tr");
  const data = [];

  for (let i = 1; i < rows.length; i++) {
    const cells = rows[i].getElementsByTagName("td");
    let minTempSymbol = "";
    let minTemp = 0;
    let maxTempSymbol = "";
    let maxTemp = 0;

    let minTimeSymbol = "";
    let minTime = 0;
    let maxTimeSymbol = "";
    let maxTime = 0;

    let message = "";

    for (let j = 0; j < 5; j++) {
      if (j == 0) {
        let selectedOption =
          cells[j].getElementsByTagName("select")[0].options[
            cells[j].getElementsByTagName("select")[0].selectedIndex
          ];
        let selectedText = selectedOption.text;

        minTempSymbol = selectedText;

        minTemp = cells[j].getElementsByTagName("input")[0].value;
      }
      if (j == 1) {
        let selectedOption =
          cells[j].getElementsByTagName("select")[0].options[
            cells[j].getElementsByTagName("select")[0].selectedIndex
          ];
        let selectedText = selectedOption.text;

        maxTempSymbol = selectedText;

        maxTemp = cells[j].getElementsByTagName("input")[0].value;
      }
      if (j == 2) {
        let selectedOption =
          cells[j].getElementsByTagName("select")[0].options[
            cells[j].getElementsByTagName("select")[0].selectedIndex
          ];
        let selectedText = selectedOption.text;

        minTimeSymbol = selectedText;

        minTime = cells[j].getElementsByTagName("input")[0].value;
      }
      if (j == 3) {
        let selectedOption =
          cells[j].getElementsByTagName("select")[0].options[
            cells[j].getElementsByTagName("select")[0].selectedIndex
          ];
        let selectedText = selectedOption.text;

        maxTimeSymbol = selectedText;

        maxTime = cells[j].getElementsByTagName("input")[0].value;
      }
      if (j == 4) {
        message = cells[j].getElementsByTagName("textarea")[0].value.trim();
      }
    }
    data.push([
      minTempSymbol,
      minTemp,
      maxTempSymbol,
      maxTemp,
      minTimeSymbol,
      minTime,
      maxTimeSymbol,
      maxTime,
      message,
    ]);
  }
  return data;
};

export const validateTempMessageEmpty = (
  tableData,
  setShowErrorMessage,
  setErrorMessage
) => {
  // Method to validate empty rows.
  let tmpTableData = tableData;

  let result = true;
  let errorRows = [];
  let errorRowsString = "";
  for (let i = 0; i < tmpTableData.length; i++) {
    if (tmpTableData[i][8] == "") {
      const rno = i + 1;
      errorRows.push(i);
      errorRowsString = errorRowsString + " , " + rno;
      highlightRows(rno);
      result = false;
    }
  }

  if (!result) {
    setShowErrorMessage(true);
    setErrorMessage(
      "Empty messages are detected at row number : " +
        errorRowsString +
        "<br><br>Please add temperature information in the empty rows"
    );
  }

  return result;
};

export const validateTempMessageInvalid = (
  tableData,
  setShowErrorMessage,
  setErrorMessage,
  regex
) => {
  let tmpTableData = tableData;
  
  let result = true;
  let errorRows = [];
  let errorRowsString = "";
  for (let i = 0; i < tmpTableData.length; i++) {
    if (regex.Emoji_Regex.test(tmpTableData[i][8]) || regex.Script_Regex.test(tmpTableData[i][8])) {
      const rno = i + 1;
      errorRows.push(i);
      errorRowsString = errorRowsString + " , " + rno;
      highlightRows(rno);
      result = false;
    }
  }

  if (!result) {
    setShowErrorMessage(true);
    setErrorMessage(
      "Invalid messages are detected at row number : " +
        errorRowsString);
  }

  return result;
};

export const validateTemperatureEmpty = (
  tableData,
  setShowErrorMessage,
  setErrorMessage
) => {
  // Method to validate empty rows.
  let tmpTableData = tableData;

  let result = true;
  let errorRows = [];
  let errorRowsString = "";
  for (let i = 0; i < tmpTableData.length; i++) {
    if (tmpTableData[i][1] == "" && tmpTableData[i][3] == "") {
      const rno = i + 1;
      errorRows.push(i);
      errorRowsString = errorRowsString + " , " + rno;
      highlightRows(rno);
      result = false;
    }
  }

  if (!result) {
    setShowErrorMessage(true);
    setErrorMessage(
      "Empty rows detected at row number : " +
        errorRowsString +
        "<br><br>Please delete the empty rows"
    );
  }

  return result;
};

export const validateTemperatureSymbolOrder = (
  tableData,
  setShowErrorMessage,
  setErrorMessage
) => {
  // Method to validate Symbol of the temprature Symbol order
  let tmpTableData = tableData;
  let result = true;

  let prevSymbol = null;
  let currentSymbol = null;
  let errorRows = [];
  let errorRowsString = "";
  for (let i = 0; i < tmpTableData.length; i++) {
    const rno = i + 1;
    if (i == 0 && tmpTableData[i][0] != "<") {
      errorRows.push(i);
      errorRowsString = errorRowsString + " , " + rno;
      setShowErrorMessage(true);
      setErrorMessage(
        "First set rules should be having '<' symbol to define the -Infinity to " +
          tmpTableData[i][1] +
          " "
      );
      highlightRows(rno);

      result = false;
      return result;
    } else if (i == tmpTableData.length - 1 && tmpTableData[i][0] != ">") {
      errorRows.push(i);
      errorRowsString = errorRowsString + " , " + rno;
      setShowErrorMessage(true);
      setErrorMessage(
        " Last set rules should be having '>' symbol to define the interval between " +
          tmpTableData[i][1] +
          " to +Infinity "
      );
      highlightRows(rno);

      result = false;
      return result;
    } else {
      currentSymbol = tmpTableData[i][0];
      if (
        prevSymbol == "<" &&
        !(currentSymbol == ">=" || currentSymbol == "<")
      ) {
        errorRows.push(i);
        errorRowsString = errorRowsString + " , " + rno;
        setShowErrorMessage(true);
        setErrorMessage(
          "Error at line : " +
            rno +
            " <br><br> " +
            currentSymbol +
            " is not allowed here.. Select '>=' or '<' "
        );
        highlightRows(rno);

        result = false;
        return result;
      } else if (
        prevSymbol == ">=" &&
        !(currentSymbol == ">=" || currentSymbol == ">")
      ) {
        errorRows.push(i);
        errorRowsString = errorRowsString + " , " + rno;
        setShowErrorMessage(true);
        setErrorMessage(
          "Error at line : " +
            rno +
            " <br><br> " +
            currentSymbol +
            " is not allowed here.. Select '>=' or '>' "
        );
        highlightRows(rno);

        result = false;
        return result;
      } else if (prevSymbol == ">" && currentSymbol != ">") {
        errorRows.push(i);
        errorRowsString = errorRowsString + " , " + rno;
        setShowErrorMessage(true);
        setErrorMessage(
          "Validation Failure <br><br> 1. Either correct Error at line : " +
            rno +
            " <br><br>  " +
            currentSymbol +
            " is not allowed here.. Select only '>' <br><br> Or 2. Error at line : " +
            (rno - 1) +
            " Correct symbol   to '>=' "
        );
        highlightRows(rno);

        result = false;
        return result;
      }
    }
    prevSymbol = tmpTableData[i][0];
  }

  return result;
};

export const validateTemperatureValue = (
  tableData,
  setShowErrorMessage,
  setErrorMessage
) => {
  // Method to validate temperature values
  let tmpTableData = tableData;
  let result = true;
  let prevSymbol = null;
  let currentSymbol = null;
  let errorRows = [];
  let errorRowsString = "";
  for (let i = 0; i < tmpTableData.length; i++) {
    const rno = i + 1;

    if (tmpTableData[i][0] != "<" && tmpTableData[i][0] != ">") {
      if (!(parseFloat(tmpTableData[i][1]) < parseFloat(tmpTableData[i][3]))) {
        errorRows.push(i);
        errorRowsString = errorRowsString + " , " + rno;
        setShowErrorMessage(true);
        setErrorMessage(
          "Error at row : " +
            rno +
            " <br><br> Min Temp Value  : " +
            tmpTableData[i][1] +
            " should be lesser than Max Temp Value : " +
            tmpTableData[i][3]
        );
        highlightRows(rno);

        result = false;
        return result;
      }
    }
    if (tmpTableData[i][0] == "<") {
      if (tmpTableData[i][3] != "") {
        errorRows.push(i);
        errorRowsString = errorRowsString + " , " + rno;
        setShowErrorMessage(true);
        setErrorMessage(
          "Error at row : " +
            rno +
            " <br><br> For First set of Temperature range Maximum Temperature should be empty. Remove the value  " +
            tmpTableData[i][3]
        );
        highlightRows(rno);

        result = false;
        return result;
      }
    }
    if (tmpTableData[i][0] == ">") {
      if (tmpTableData[i][3] != "") {
        errorRows.push(i);
        errorRowsString = errorRowsString + " , " + rno;
        setShowErrorMessage(true);
        setErrorMessage(
          "Error at row : " +
            rno +
            " <br><br> For Last set of Temperature range Maximum Temperature should be empty. Remove the value  " +
            tmpTableData[i][3]
        );
        result = false;
        return result;
      }
    }
  }

  return result;
};

export const validateTemperatureRange = (
  tableData,
  setShowErrorMessage,
  setErrorMessage
) => {
  // Method to validate Symbol of the temprature Symbol order
  let tmpTableData = tableData;
  let result = true;
  let prevMinSymbol = null;
  let prevMaxSymbol = null;
  let prevMinTemp = null;
  let prevMaxTemp = null;
  let currentMinSymbol = null;
  let currentMaxSymbol = null;
  let currentMinTemp = null;
  let currentMaxTemp = null;
  let errorRows = [];
  let errorRowsString = "";
  for (let i = 0; i < tmpTableData.length; i++) {
    const rno = i + 1;

    if (i > 0) {
      currentMinSymbol = tmpTableData[i][0];
      currentMinTemp = tmpTableData[i][1];
      currentMaxSymbol = tmpTableData[i][2];
      currentMaxTemp = tmpTableData[i][3];

      if (prevMinSymbol == "<") {
        if (currentMinSymbol == "<") {
          if (prevMinTemp != currentMinTemp) {
            errorRows.push(i);
            errorRowsString = errorRowsString + " , " + rno;
            setShowErrorMessage(true);
            setErrorMessage(
              "Error at row : " +
                rno +
                " <br><br> First set of Temperature range rules  should have  Minimum temperature " +
                prevMinTemp
            );
            highlightRows(rno);

            result = false;
            return result;
          }
        }
        if (currentMinSymbol == ">=") {
          if (prevMinTemp != currentMinTemp) {
            errorRows.push(i);
            errorRowsString = errorRowsString + " , " + rno;
            setShowErrorMessage(true);
            setErrorMessage(
              "Error at row : " +
                rno +
                " <br><br> Second  temperature range rules should have Minimum Temperature as  " +
                prevMinTemp
            );
            highlightRows(rno);

            result = false;
            return result;
          }
        }
      }

      if (prevMinSymbol == ">=") {
        if (currentMinSymbol == ">=") {
          if (parseFloat(currentMinTemp) != parseFloat(prevMinTemp)) {
            if (parseFloat(currentMinTemp) - parseFloat(prevMaxTemp) != 1) {
              errorRows.push(i);
              errorRowsString = errorRowsString + " , " + rno;
              setShowErrorMessage(true);
              setErrorMessage(
                "Error at row : " +
                  rno +
                  " <br><br> Temperature Range mismatch. This row should have Minimum Temperature value as " +
                  (parseFloat(prevMaxTemp) + 1)
              );
              highlightRows(rno);

              result = false;
              return result;
            }
          }
          if (parseFloat(currentMinTemp) == parseFloat(prevMinTemp)) {
            if (parseFloat(currentMaxTemp) != parseFloat(prevMaxTemp)) {
              errorRows.push(i);
              errorRowsString = errorRowsString + " , " + rno;
              setShowErrorMessage(true);
              setErrorMessage(
                "Error at row : " +
                  rno +
                  " <br><br> Temperature Range mismatch. Expected Temperature range value is Min Temp : " +
                  parseFloat(prevMinTemp) +
                  " to  Max Temp : " +
                  parseFloat(prevMaxTemp) +
                  " <br><br>  Maximum Temperature value is " +
                  parseFloat(currentMaxTemp) +
                  " and it  should be corrected to : " +
                  parseFloat(prevMaxTemp) +
                  " "
              );
              highlightRows(rno);

              result = false;
              return result;
            }
          }
        }

        if (currentMinSymbol == ">") {
          if (prevMaxTemp != currentMinTemp) {
            errorRows.push(i);
            errorRowsString = errorRowsString + " , " + rno;
            setShowErrorMessage(true);
            setErrorMessage(
              "Error at row : " +
                rno +
                " <br><br> Last set of Temperature range rules  should have  Minimum temperature " +
                prevMaxTemp
            );
            highlightRows(rno);

            result = false;
            return result;
          }
        }
      }

      if (prevMinSymbol == ">") {
        if (prevMinTemp != currentMinTemp) {
          errorRows.push(i);
          errorRowsString = errorRowsString + " , " + rno;
          setShowErrorMessage(true);
          setErrorMessage(
            "Error at row : " +
              rno +
              " <br><br> Last set of Temperature range rules  should have  Minimum temperature " +
              prevMinTemp
          );
          highlightRows(rno);

          result = false;
          return result;
        }
      }
    }

    prevMinSymbol = tmpTableData[i][0];
    prevMinTemp = tmpTableData[i][1];
    prevMaxSymbol = tmpTableData[i][2];
    prevMaxTemp = tmpTableData[i][3];
  }

  return result;
};

export const validateDuplicateEntries = (
  tableData,
  setShowErrorMessage,
  setErrorMessage
) => {
  // Method to validate empty rows.
  var tmpTableData = tableData;

  var result = true;
  var errorRows = [];
  var errorRowsString = "";
  var duplicateEntries = findDuplicateRows(tableData);
  if (duplicateEntries.length > 0) {
    for (let i = 0; i < tableData.length; i++) {
      const rno = i + 1;
      for (let j = 0; j < duplicateEntries.length; j++) {
        if (
          JSON.stringify(tableData[i]) == JSON.stringify(duplicateEntries[j])
        ) {
          errorRows.push(i);
          errorRowsString += " , " + rno;
          highlightRows(rno);
        }
      }
    }

    setShowErrorMessage(true);
    setErrorMessage(" Duplicate Rows found.  " + errorRowsString);

    result = false;
    return result;
  }

  return result;
};
const findDuplicateRows = (arr) => {
  const seenRows = new Set();
  const duplicateRows = [];

  for (const row of arr) {
    const rowString = JSON.stringify(row);

    if (seenRows.has(rowString)) {
      duplicateRows.push(row);
    } else {
      seenRows.add(rowString);
    }
  }

  return duplicateRows;
};

export const validateTimeAnydurationCheck = (
  tableData,
  setShowErrorMessage,
  setErrorMessage
) => {
  var result = true;
  var tempTimeArr = new Array();
  var currentMinSymbol = null;
  var currentMaxSymbol = null;
  var currentMinTemp = null;
  var currentMaxTemp = null;
  var currentMinTimeSymbol = null;
  var currentMaxTimeSymbol = null;
  var currentMinTime = null;
  var currentMaxTime = null;
  var errorRows = [];

  for (let i = 0; i < tableData.length; i++) {
    currentMinSymbol = tableData[i][0];
    currentMinTemp = tableData[i][1];
    currentMaxSymbol = tableData[i][2];
    currentMaxTemp = tableData[i][3];
    currentMinTimeSymbol = tableData[i][4];
    currentMinTime = tableData[i][5];
    currentMaxTimeSymbol = tableData[i][6];
    currentMaxTime = tableData[i][7];
    if (
      !tempTimeArr[
        currentMinSymbol +
          "|" +
          currentMinTemp +
          "|" +
          currentMaxSymbol +
          "|" +
          currentMaxTemp
      ]
    ) {
      tempTimeArr[
        currentMinSymbol +
          "|" +
          currentMinTemp +
          "|" +
          currentMaxSymbol +
          "|" +
          currentMaxTemp
      ] = new Array();
      tempTimeArr[
        currentMinSymbol +
          "|" +
          currentMinTemp +
          "|" +
          currentMaxSymbol +
          "|" +
          currentMaxTemp
      ][0] = [
        currentMinTimeSymbol,
        currentMinTime,
        currentMaxTimeSymbol,
        currentMaxTime,
      ];
    } else {
      tempTimeArr[
        currentMinSymbol +
          "|" +
          currentMinTemp +
          "|" +
          currentMaxSymbol +
          "|" +
          currentMaxTemp
      ][
        tempTimeArr[
          currentMinSymbol +
            "|" +
            currentMinTemp +
            "|" +
            currentMaxSymbol +
            "|" +
            currentMaxTemp
        ].length
      ] = [
        currentMinTimeSymbol,
        currentMinTime,
        currentMaxTimeSymbol,
        currentMaxTime,
      ];
    }
  }

  for (const index in tempTimeArr) {
    var strcurrenttemprange = index;
    var arrTimeRanges = tempTimeArr[index];
    var isAnyDurationAvailable = false;
    for (let k = 0; k < arrTimeRanges.length; k++) {
      var tt = arrTimeRanges[k];

      if (tt[1] == "" && tt[3] == "") {
        isAnyDurationAvailable = true;
      }
    }

    if (isAnyDurationAvailable && arrTimeRanges.length > 1) {
      const testArray = strcurrenttemprange.split("|");

      if (testArray[0] == "<") {
        setShowErrorMessage(true);
        setErrorMessage(
          "First set of Temperature range consists values 'Any duration (both time inputs blank) ' and also Time ranges defined. <br><br> Remove Any duration (both time inputs blank) or Remove the time Ranges defined."
        );
      } else if (testArray[0] == ">") {
        setShowErrorMessage(true);
        setErrorMessage(
          "Last set of Temperature range consists values 'Any duration (both time inputs blank) ' and also Time ranges defined. <br><br> Remove Any duration (both time inputs blank) or Remove the time Ranges defined."
        );
      } else {
        setShowErrorMessage(true);
        setErrorMessage(
          "For the Temperature range '" +
            testArray[1] +
            "°C' to '" +
            testArray[3] +
            "°C' consists values 'Any duration (both time inputs blank) ' and also Time ranges defined. <br><br> Remove Any duration (both time inputs blank) or Remove the time Ranges defined."
        );
      }
      errorRows = findPositionOfTempRange(tableData, testArray);

      result = false;
      return result;
    }
  }

  return result;
};

export const validateTimeSymbolCheck = (
  tableData,
  setShowErrorMessage,
  setErrorMessage
) => {
  var result = true;
  var tempTimeArr = new Array();
  var currentMinSymbol = null;
  var currentMaxSymbol = null;
  var currentMinTemp = null;
  var currentMaxTemp = null;
  var currentMinTimeSymbol = null;
  var currentMaxTimeSymbol = null;
  var currentMinTime = null;
  var currentMaxTime = null;
  var errorRows = [];

  for (let i = 0; i < tableData.length; i++) {
    currentMinSymbol = tableData[i][0];
    currentMinTemp = tableData[i][1];
    currentMaxSymbol = tableData[i][2];
    currentMaxTemp = tableData[i][3];
    currentMinTimeSymbol = tableData[i][4];
    currentMinTime = tableData[i][5];
    currentMaxTimeSymbol = tableData[i][6];
    currentMaxTime = tableData[i][7];
    if (
      !tempTimeArr[
        currentMinSymbol +
          "|" +
          currentMinTemp +
          "|" +
          currentMaxSymbol +
          "|" +
          currentMaxTemp
      ]
    ) {
      tempTimeArr[
        currentMinSymbol +
          "|" +
          currentMinTemp +
          "|" +
          currentMaxSymbol +
          "|" +
          currentMaxTemp
      ] = new Array();
      tempTimeArr[
        currentMinSymbol +
          "|" +
          currentMinTemp +
          "|" +
          currentMaxSymbol +
          "|" +
          currentMaxTemp
      ][0] = [
        currentMinTimeSymbol,
        currentMinTime,
        currentMaxTimeSymbol,
        currentMaxTime,
      ];
    } else {
      tempTimeArr[
        currentMinSymbol +
          "|" +
          currentMinTemp +
          "|" +
          currentMaxSymbol +
          "|" +
          currentMaxTemp
      ][
        tempTimeArr[
          currentMinSymbol +
            "|" +
            currentMinTemp +
            "|" +
            currentMaxSymbol +
            "|" +
            currentMaxTemp
        ].length
      ] = [
        currentMinTimeSymbol,
        currentMinTime,
        currentMaxTimeSymbol,
        currentMaxTime,
      ];
    }
  }

  for (const index in tempTimeArr) {
    var strcurrenttemprange = index;
    var arrTimeRanges = tempTimeArr[index];
    const testArray = strcurrenttemprange.split("|");

    var prevmintimesymbol = null;
    var prevmintimehrs = null;
    var prevmaxtimesymbol = null;
    var prevmaxtimehrs = null;

    for (let k = 0; k < arrTimeRanges.length; k++) {
      var tt = arrTimeRanges[k];
      var mintimesymbol = tt[0];
      var mintimehrs = tt[1];
      var maxtimesymbol = tt[2];
      var maxtimehrs = tt[3];

      if (mintimehrs == "" && maxtimehrs == "") {
        //Anyduration - success
      }
      if (mintimehrs != "" || maxtimehrs != "") {
        //Duration with some hours either in min hrs field or max hrs field
        if (k == 0) {
          if (mintimesymbol != "<=") {
            errorRows = findPositionOfTempAndHrsRange(tableData, testArray, tt);

            setShowErrorMessage(true);
            setErrorMessage(
              "Error at row : " +
                (parseFloat(errorRows) + 1) +
                " First line Time hrs symbol should be '<=' "
            );

            result = false;
            return result;
          } else {
            if (arrTimeRanges.length == 1) {
              errorRows = findPositionOfTempAndHrsRange(
                tableData,
                testArray,
                tt
              );
              setShowErrorMessage(true);
              setErrorMessage(
                "Error at row :  " +
                  (parseFloat(errorRows) + 1) +
                  " <br><br> Time range > " +
                  mintimehrs +
                  " hrs is not defined"
              );

              result = false;
              return result;
            }
          }
        } else {
          if (prevmintimesymbol == "<=" || prevmintimesymbol == ">") {
            if (mintimesymbol != ">") {
              errorRows = findPositionOfTempAndHrsRange(
                tableData,
                testArray,
                tt
              );

              setShowErrorMessage(true);
              setErrorMessage(
                "Error at row :  " +
                  (parseFloat(errorRows) + 1) +
                  " <br><br> Time range - Minimum time symbol '" +
                  mintimesymbol +
                  "' not allowed. Expected : '>'"
              );

              result = false;
              return result;
            }
          }
        }
      }

      prevmintimesymbol = mintimesymbol;
      prevmintimehrs = mintimehrs;
      prevmaxtimesymbol = maxtimesymbol;
      prevmaxtimehrs = maxtimehrs;
    }
  }

  return result;
};

export const validateTimeHRSCheck = (
  tableData,
  setShowErrorMessage,
  setErrorMessage
) => {
  var result = true;
  var tempTimeArr = new Array();
  var currentMinSymbol = null;
  var currentMaxSymbol = null;
  var currentMinTemp = null;
  var currentMaxTemp = null;
  var currentMinTimeSymbol = null;
  var currentMaxTimeSymbol = null;
  var currentMinTime = null;
  var currentMaxTime = null;
  var errorRows = [];

  for (let i = 0; i < tableData.length; i++) {
    currentMinSymbol = tableData[i][0];
    currentMinTemp = tableData[i][1];
    currentMaxSymbol = tableData[i][2];
    currentMaxTemp = tableData[i][3];
    currentMinTimeSymbol = tableData[i][4];
    currentMinTime = tableData[i][5];
    currentMaxTimeSymbol = tableData[i][6];
    currentMaxTime = tableData[i][7];
    if (
      !tempTimeArr[
        currentMinSymbol +
          "|" +
          currentMinTemp +
          "|" +
          currentMaxSymbol +
          "|" +
          currentMaxTemp
      ]
    ) {
      tempTimeArr[
        currentMinSymbol +
          "|" +
          currentMinTemp +
          "|" +
          currentMaxSymbol +
          "|" +
          currentMaxTemp
      ] = new Array();
      tempTimeArr[
        currentMinSymbol +
          "|" +
          currentMinTemp +
          "|" +
          currentMaxSymbol +
          "|" +
          currentMaxTemp
      ][0] = [
        currentMinTimeSymbol,
        currentMinTime,
        currentMaxTimeSymbol,
        currentMaxTime,
      ];
    } else {
      tempTimeArr[
        currentMinSymbol +
          "|" +
          currentMinTemp +
          "|" +
          currentMaxSymbol +
          "|" +
          currentMaxTemp
      ][
        tempTimeArr[
          currentMinSymbol +
            "|" +
            currentMinTemp +
            "|" +
            currentMaxSymbol +
            "|" +
            currentMaxTemp
        ].length
      ] = [
        currentMinTimeSymbol,
        currentMinTime,
        currentMaxTimeSymbol,
        currentMaxTime,
      ];
    }
  }

  for (const index in tempTimeArr) {
    var strcurrenttemprange = index;
    var arrTimeRanges = tempTimeArr[index];
    const testArray = strcurrenttemprange.split("|");

    var prevmintimesymbol = null;
    var prevmintimehrs = null;
    var prevmaxtimesymbol = null;
    var prevmaxtimehrs = null;

    for (let k = 0; k < arrTimeRanges.length; k++) {
      var tt = arrTimeRanges[k];
      var mintimesymbol = tt[0];
      var mintimehrs = tt[1];
      var maxtimesymbol = tt[2];
      var maxtimehrs = tt[3];

      if (mintimehrs == "" && maxtimehrs == "") {
        //Anyduration - success
      }
      if (mintimehrs != "" || maxtimehrs != "") {
        //Duration with some hours either in min hrs field or max hrs field
        if (k == 0) {
          if (maxtimehrs != "") {
            errorRows = findPositionOfTempAndHrsRange(tableData, testArray, tt);

            setShowErrorMessage(true);
            setErrorMessage(
              "Error at row : " +
                (parseFloat(errorRows) + 1) +
                " <br><br> First line Time hrs should not have Maximum Time hours. <br><br> Remove value for Maximum Time hours value. "
            );

            result = false;
            return result;
          }
        } else {
          if (prevmintimesymbol == "<=") {
            if (mintimehrs != prevmintimehrs) {
              errorRows = findPositionOfTempAndHrsRange(
                tableData,
                testArray,
                tt
              );

              setShowErrorMessage(true);
              setErrorMessage(
                "Error at row :  " +
                  (parseFloat(errorRows) + 1) +
                  " <br><br> Minimum Time hours should be  '" +
                  prevmintimehrs +
                  "' hrs"
              );

              result = false;
              return result;
            }
            if (
              maxtimehrs != "" &&
              parseFloat(maxtimehrs) <= parseFloat(mintimehrs)
            ) {
              errorRows = findPositionOfTempAndHrsRange(
                tableData,
                testArray,
                tt
              );

              setShowErrorMessage(true);
              setErrorMessage(
                "Error at row :  " +
                  (parseFloat(errorRows) + 1) +
                  " <br><br> Maximum Time hours : " +
                  parseFloat(maxtimehrs) +
                  " should be Greater than  '" +
                  parseFloat(mintimehrs) +
                  "' hrs"
              );

              result = false;
              return result;
            }
          }

          if (prevmintimesymbol == ">" && prevmaxtimehrs != "") {
            if (mintimehrs != prevmaxtimehrs) {
              errorRows = findPositionOfTempAndHrsRange(
                tableData,
                testArray,
                tt
              );

              setShowErrorMessage(true);
              setErrorMessage(
                "Error at row :  " +
                  (parseFloat(errorRows) + 1) +
                  " <br><br> Minimum Time hours should be --  '" +
                  prevmaxtimehrs +
                  "' hrs"
              );

              result = false;
              return result;
            }
          }
          if (prevmintimesymbol == ">" && prevmaxtimehrs == "") {
            if (mintimehrs != prevmaxtimehrs) {
              errorRows = findPositionOfTempAndHrsRange(
                tableData,
                testArray,
                tt
              );
              errorRows = parseFloat(errorRows) - 1;

              setShowErrorMessage(true);
              setErrorMessage(
                "Error at row :  " +
                  (parseFloat(errorRows) + 1) +
                  " <br><br> Maximum Time hours should not be  Empty."
              );

              result = false;
              return result;
            }
          }
        }
      }

      prevmintimesymbol = mintimesymbol;
      prevmintimehrs = mintimehrs;
      prevmaxtimesymbol = maxtimesymbol;
      prevmaxtimehrs = maxtimehrs;
    }
  }

  return result;
};

const findPositionOfTempAndHrsRange = (tableData, testArray, tt) => {
  var mintimesymbol = tt[0];
  var mintimehrs = tt[1];
  var maxtimesymbol = tt[2];
  var maxtimehrs = tt[3];

  var minTempSymbol = testArray[0];
  var minTemp = testArray[1];
  var maxTempSymbol = testArray[2];
  var maxTemp = null;
  var errorRow = null;

  if (minTempSymbol == "<" || minTempSymbol == ">") {
    maxTemp = "";
  } else {
    maxTemp = testArray[3];
  }

  for (let i = 0; i < tableData.length; i++) {
    if (
      minTempSymbol == tableData[i][0] &&
      minTemp == tableData[i][1] &&
      maxTempSymbol == tableData[i][2] &&
      maxTemp == tableData[i][3] &&
      mintimesymbol == tableData[i][4] &&
      mintimehrs == tableData[i][5] &&
      maxtimesymbol == tableData[i][6] &&
      maxtimehrs == tableData[i][7]
    ) {
      errorRow = i;
    }
  }

  return errorRow;
};

const findPositionOfTempRange = (tableData, testArray) => {
  var validateSymbol = testArray[0];
  var errorRows = [];

  if (validateSymbol == "<" || validateSymbol == ">") {
    for (let i = 0; i < tableData.length; i++) {
      if (
        validateSymbol == tableData[i][0] &&
        testArray[1] == tableData[i][1]
      ) {
        errorRows.push(i);
      }
    }
  } else {
    for (let i = 0; i < tableData.length; i++) {
      if (testArray[1] == tableData[i][1] && testArray[3] == tableData[i][3]) {
        errorRows.push(i);
      }
    }
  }

  return errorRows;
};



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/TET/TETRuleValidation.js